import { useEffect, useMemo, useState } from 'react'
import { effectiveMenuItem, type CampaignPriced } from '../lib/menuCampaign'

// #1711 期限切れのキャンペーン価格を通常価格へ戻したメニューを返す。
//
// 正はサーバ (API が返す menu は既に戻っている)。ここは**開いたまま期限をまたいだ端末**
// の保険で、客の商品一覧だけでなく**レジとスタッフ注文**にも当てる — レジが ¥550 と
// 言って客から現金を受け取り、サーバが ¥1,100 で計上する (釣り銭・レシートが合わない)
// のを防ぐため。サーバは価格を再計算するので金は正しいが、画面の見積りが違うと現場が困る。
//
// 期限の判定時刻は 1 分ごとと画面復帰 (visibilitychange) で更新する。useMemo に
// `new Date()` を閉じ込めるだけだと、menu の参照が変わるまで再評価されず、
// 「開きっぱなし」の場面でこそ効かない。
export function useEffectiveMenu<T extends CampaignPriced>(menu: T[] | null | undefined): T[] {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const tick = () => setNow(Date.now())
    const id = window.setInterval(tick, 60_000)
    document.addEventListener('visibilitychange', tick)
    return () => {
      window.clearInterval(id)
      document.removeEventListener('visibilitychange', tick)
    }
  }, [])
  return useMemo(() => {
    const at = new Date(now)
    const list = menu ?? []
    const next = list.map((m) => effectiveMenuItem(m, at))
    // 何も戻していなければ元の配列を返す (参照が変わって下流の memo を無駄に壊さない)
    return next.every((m, i) => m === list[i]) ? list : next
  }, [menu, now])
}
